import React from "react";

import { ENVIRONMENT } from "./Environment";

export * from "./Environment";

export const EnvironmentContext = React.createContext(ENVIRONMENT);
